import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

type Props = {
  orgId: string;
  isMember: boolean;
  disabled: boolean;
  onJoin: () => void;
  onLeave: () => void;
};

export function OrgMemberButton({
  orgId,
  isMember,
  disabled,
  onJoin,
  onLeave,
}: Props) {
  const { i18n } = useI18n();

  if (isMember) {
    return (
      <Button
        type="button"
        variant="secondary"
        qaId="join-group"
        disabled={disabled}
        onClick={() => {
          trackClicked('Leave Group', { org_id: orgId });
          onLeave();
        }}
      >
        {i18n('Leave group')}
      </Button>
    );
  }

  return (
    <Button
      type="button"
      variant="primary"
      qaId="join-group"
      disabled={disabled}
      onClick={() => {
        trackClicked('Join Group', { org_id: orgId });
        onJoin();
      }}
    >
      {i18n('Join group')}
    </Button>
  );
}
